import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	issuesInVersion: {
		id: 'version-issue-associated-designs.design-carousel.design-card.issues-modal.body.issues-in-version',
		defaultMessage: 'Current version',
		description: 'Title shown above a list of issues that appear in the current version.',
	},
	otherIssues: {
		id: 'version-issue-associated-designs.design-carousel.design-card.issues-modal.body.other-issues',
		defaultMessage: 'Other',
		description: 'Title shown above a list of issues that do not appear in the current version.',
	},
});
